import { Component, OnInit, Inject } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-campus-news-events-list",
  templateUrl: "./campus-news-events-list.component.html",
  styleUrls: ["./campus-news-events-list.component.scss"],
})
export class CampusNewsEventsListComponent implements OnInit {
  constructor(
    private http: HttpClient,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  public list = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint + "/campus-news-events/").subscribe(
      (data) => {
        this.list = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      }
    );
  }

  delete(id) {
    // console.log(this.Form.value)
    if (confirm("Are you sure to delete ")) {
      this.http.delete<any>(this.api_endpoint + "/campus-news-events/" + id).subscribe(
        (res) => {
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Deleted";
            this.class = "btn btn-success";
            this.ngOnInit();
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
